/**
 * Vehicle Valuation Service API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';


import { VPError } from '../model/vPError';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class ImageFrameFilesViewService {

    protected basePath = 'https://localhost';
    protected defaultHeaders = new HttpHeaders();
    protected configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * AmsAction:GET/api/ImageFrameFilesView/case/{caseId}/frame/{frameId}/generateJpg/{fileKey} AmsResource:{country}/{business}/case/{caseId} 
     * @param caseId 
     * @param frameId 
     * @param fileKey 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public generateJpgAsync(caseId: string, frameId: string, fileKey: string, observe?: 'body', reportProgress?: boolean): Observable<Blob>;
    public generateJpgAsync(caseId: string, frameId: string, fileKey: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Blob>>;
    public generateJpgAsync(caseId: string, frameId: string, fileKey: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Blob>>;
    public generateJpgAsync(caseId: string, frameId: string, fileKey: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (caseId === null || caseId === undefined) {
            throw new Error('Required parameter caseId was null or undefined when calling generateJpgAsync.');
        }

        if (frameId === null || frameId === undefined) {
            throw new Error('Required parameter frameId was null or undefined when calling generateJpgAsync.');
        }

        if (fileKey === null || fileKey === undefined) {
            throw new Error('Required parameter fileKey was null or undefined when calling generateJpgAsync.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'image/jpeg'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Blob>(`${this.basePath}/api/ImageFrameFilesView/case/${encodeURIComponent(String(caseId))}/frame/${encodeURIComponent(String(frameId))}/generateJpg/${encodeURIComponent(String(fileKey))}`,
            {
                // @ts-ignore
                responseType:'blob',
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
